module.exports = __webpack_public_path__ + "img/Login-Page-Animation.09396437.jpg";